import { render, staticRenderFns } from "./CardsPile.vue?vue&type=template&id=d01f60d8&"
import script from "./CardsPile.vue?vue&type=script&lang=js&"
export * from "./CardsPile.vue?vue&type=script&lang=js&"
import style0 from "./CardsPile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports